import { createSlice } from "@reduxjs/toolkit";
import { STATES_NAMES } from "../../enums/Enums";

const parkersInitialState = {
  // parkers: [],
  parkersColumns:[],
  guestsColumns:[],
  gmtColumns:[],
};

const parkersSlice = createSlice({
  name: STATES_NAMES.PARKERS,
  initialState: parkersInitialState,
  reducers: {
    setParkersColumns(state, action){
      state.parkersColumns = action.payload;
    },
    setGuestsColumns(state, action){
      state.guestsColumns = action.payload;
    },
    setGmtColumns(state, action){
      state.gmtColumns = action.payload;
    },
  },
});

export const parkersActions = parkersSlice.actions;

export default parkersSlice.reducer;
